export const DEFAULT_LOGO_URL =
    'https://marketingcdn.giftcardgranny.com/Homepage/images/gcg-logo.svg'

export const VALENTINES_LOGO_URL =
    'https://res.cloudinary.com/gift-card-granny/image/upload/f_webp/v1768339661/GCG/assets/logos/Brand_GiftYa_Color_Full_Division_Main_Icon_No_Orientation_Horizontal_Smiling_Wolf_No_size_Default_twga0m'

export const MOTHERS_DAY_LOGO_URL =
    'https://res.cloudinary.com/gift-card-granny/image/upload/v1775240698/GCG/assets/logos/GCG_MOTHERS_1_mjjjzg.webp'

export const FATHERS_DAY_LOGO_URL =
    'https://res.cloudinary.com/gift-card-granny/image/upload/f_webp,w_412,q_auto:best/v1779909318/GCG/assets/logos/GCG_FathersDay_yagxg6.png'

export const BACK_TO_SCHOOL_LOGO_URL =
    'https://res.cloudinary.com/gift-card-granny/image/upload/f_webp,w_412,q_auto:best/v1783360717/GCG/assets/logos/GCG-B2S_gezj0k.png'
